<template>
    <div class="card mt-3">
        <div class="card-body">
            <h5 class="card-title">Azure Hostname</h5>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">IoT Hub Name</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="serverData.azure.hostname" />
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">Azure Port Number</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        :class="{ 'is-invalid': portNumberError }"
                        v-model="serverData.azure.portNumber"
                        @change="validatePort" />
                    <div class="invalid-feedback">Numbers ranging from 1 to 65535 only</div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">Device ID</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="serverData.azure.deviceid" />
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">Shared Access Policy Name</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="serverData.azure.shpolicyname" />
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">Shared Access Policy Key</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="serverData.azure.shpolicykey" />
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">Token Generation Time (in minutes)</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        :class="{ 'is-invalid': tokenTimeError }"
                        v-model="serverData.azure.tokentime"
                        @change="validateTokenTime" />
                    <div class="invalid-feedback">Numbers ranging from 1 to 1440 only</div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">Azure Client Topic Name</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="serverData.azure.topicName" />
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">QOS</label>
                </div>
                <div class="col-md-8">
                    <select
                        class="form-control form-control-sm"
                        v-model="serverData.azure.qos">
                        <option value="0">0</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                    </select>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">FTP Server Address</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        :class="{ 'is-invalid': ftpServerAddressError }"
                        v-model="serverData.azure.ftpServerAddress"
                        @change="validateFtpServerAddress" />
                    <div class="invalid-feedback">Please follow IP address format</div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">FTP Port Number</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        :class="{ 'is-invalid': ftpPortNumberError }"
                        v-model="serverData.azure.ftpPortNumber"
                        @change="validateFtpPort" />
                    <div class="invalid-feedback">Numbers ranging from 1 to 65535 only</div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">FTP Username</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="serverData.azure.ftpUsername" />
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">FTP Password</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="serverData.azure.ftpPassword" />
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">FTP Config File Path</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="serverData.azure.ftpConfigFilePath" />
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">Send Data Mode</label>
                </div>
                <div class="col-md-8">
                    <select
                        class="form-control form-control-sm"
                        v-model="serverData.azure.senddatamode">
                        <option value="0">Old Data(Saved Data)</option>
                        <option value="1">Latest Data Only</option>
                    </select>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">JSON Data View</label>
                </div>
                <div class="col-md-8">
                    <select
                        class="form-control form-control-sm"
                        v-model="serverData.azure.jsondataview">
                        <option value="0">JSON TO STRING PLAIN</option>
                        <option value="1">JSON TO STRING SPACED</option>
                        <option value="2">JSON TO STRING PRETTY</option>
                        <option value="4">JSON TO STRING NOZERO</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            serverAddressError: false,
            portNumberError: false,
            ftpServerAddressError: false,
            ftpPortNumberError: false,
            tokenTimeError: false
        }
    },
    props: ['serverData'],
    methods: {
        validateServerAddress() {
            if(/^\d{1,3}.\d{1,3}.\d{1,3}.\d{1,3}$/.test(this.serverData.azure.hostname) || /(\w+\.\w*\.?)+/.test(this.serverData.azure.hostname) || this.serverData.azure.hostname === 'NULL') {
                this.serverAddressError = false
            } else {
                this.serverAddressError = true
            }
        },
        validatePort() {
            if((/^[0-9]+$/.test(this.serverData.azure.portNumber) && (parseInt(this.serverData.azure.portNumber) > 0 && parseInt(this.serverData.azure.portNumber) < 65536)) || this.serverData.azure.portNumber === 'NULL') {
                this.portNumberError = false
            } else {
                this.portNumberError = true
            }
        },
        validateFtpServerAddress() {
            if(/^\d{1,3}.\d{1,3}.\d{1,3}.\d{1,3}$/.test(this.serverData.azure.ftpServerAddress) || this.serverData.azure.ftpServerAddress === 'NULL') {
                this.ftpServerAddressError = false
            } else {
                this.ftpServerAddressError = true
            }
        },
        validateFtpPort() {
            if((/^[0-9]+$/.test(this.serverData.azure.ftpPortNumber) && (parseInt(this.serverData.azure.ftpPortNumber) > 0 && parseInt(this.serverData.azure.ftpPortNumber) < 65536)) || this.serverData.azure.ftpPortNumber === 'NULL') {
                this.ftpPortNumberError = false
            } else {
                this.ftpPortNumberError = true
            }
        },
        validateTokenTime() {
            if((/^[0-9]+$/.test(this.serverData.azure.tokentime) && (parseInt(this.serverData.azure.tokentime) > 0 && parseInt(this.serverData.azure.tokentime) < 1441)) || this.serverData.azure.tokentime === 'NULL') {
                this.tokenTimeError = false
            } else {
                this.tokenTimeError = true
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/server-forms/AzureDetails.vue